/* ==========================================================================
   Paola & Joy — Robyn sets in the cart
   --------------------------------------------------------------------------
   The Robyn lamp is stocked as two products, so the cart holds two line items
   for one lamp. main-cart-items.liquid draws them as a single row; this keeps
   the two halves in step behind it, so changing the quantity changes both and
   Remove clears both. A customer can never be left holding half a lamp.

   Updates go through /cart/update.js, which takes line-item keys, rather than
   Dawn's /cart/change.js, which takes one line at a time.
   ========================================================================== */

(function () {
  'use strict';

  var SECTIONS = [
    { id: 'main-cart-items', selector: '.js-contents' },
    { id: 'main-cart-footer', selector: '.js-contents' },
    { id: 'cart-icon-bubble', selector: null },
    { id: 'cart-live-region-text', selector: null }
  ];

  function sectionIdFor(domId) {
    var host = document.getElementById(domId);
    if (!host) return null;
    return host.dataset.id || domId;
  }

  function busy(row, state) {
    row.classList.toggle('pj-set--busy', state);
    row.querySelectorAll('button, input').forEach(function (el) { el.disabled = state; });
  }

  function paint(sections) {
    SECTIONS.forEach(function (conf) {
      var host = document.getElementById(conf.id);
      if (!host) return;
      var html = sections[host.dataset.id || conf.id];
      if (!html) return;

      var doc = new DOMParser().parseFromString(html, 'text/html');

      if (conf.selector) {
        var src = doc.querySelector(conf.selector);
        var dest = host.querySelector(conf.selector);
        if (src && dest) dest.innerHTML = src.innerHTML;
        return;
      }

      var whole = doc.querySelector('.shopify-section');
      host.innerHTML = whole ? whole.innerHTML : html;
    });
  }

  function update(row, quantity) {
    var keys = (row.dataset.pjSetKeys || '').split('~').filter(Boolean);
    if (!keys.length) return;

    var updates = {};
    keys.forEach(function (key) { updates[key] = quantity; });

    var wanted = [];
    SECTIONS.forEach(function (c) {
      var id = sectionIdFor(c.id);
      if (id) wanted.push(id);
    });

    busy(row, true);

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        updates: updates,
        sections: wanted.join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        /* An empty cart swaps the whole section for the empty state, and the
           containers we patch into stop existing. A reload is the honest way
           to show it. */
        if (!cart.item_count) {
          window.location.reload();
          return;
        }
        if (cart.sections) paint(cart.sections);
      })
      .catch(function () {
        busy(row, false);
        window.location.reload();
      });
  }

  function rowOf(el) {
    return el.closest('[data-pj-set]');
  }

  document.addEventListener('click', function (event) {
    var step = event.target.closest('[data-pj-set-qty]');
    if (step) {
      var row = rowOf(step);
      if (!row) return;
      var input = row.querySelector('[data-pj-set-qtynum]');
      var next = Math.max(0, parseInt(input.value, 10) + parseInt(step.dataset.pjSetQty, 10));
      input.value = next;
      update(row, next);
      return;
    }

    var remove = event.target.closest('[data-pj-set-remove]');
    if (remove) {
      var removeRow = rowOf(remove);
      if (removeRow) update(removeRow, 0);
    }
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-pj-set-qtynum]');
    if (!input) return;
    var row = rowOf(input);
    if (!row) return;
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) qty = 0;
    input.value = qty;
    update(row, qty);
  });
})();
